import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { useRecoilValue } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../routes/types';
import { customerCartStatusState } from '../../../store/batchTicket/atom';
import {
  customerCartCountSelector,
  productsCartCountSelector,
} from '../../../store/batchTicket/selectors';

import { useStep } from './useStep';

export const useFooter = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { cancelOrderIsDisabled, continueButtonIsDisabled, goToNextStep, handleCancelOrder } =
    useStep();

  const customerCartCount = useRecoilValue(customerCartCountSelector);
  const productsCartCount = useRecoilValue(productsCartCountSelector);

  const customerCartStatus = useRecoilValue(customerCartStatusState);

  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const basketCartCount = customerCartCount + productsCartCount.assets;

  const handlePressBasketButton = () => {
    navigate('BatchTicketCart', {
      key: customerCartStatus === 'complete' ? 'addedProducts' : 'addedCustomers',
    });
  };

  return {
    handlePressBasketButton,
    continueButtonIsDisabled,
    goToNextStep,
    handleCancelOrder,
    cancelOrderIsDisabled,
    customerCartCount,
    isMobile,
    isDesktop,
    basketCartCount,
  };
};
